<template>
    <div class="header-view">
        <div class="header-view-content u-flex">
            <img :src="logo_pic" alt="" class="logo">
            <div class="header-center u-flex-1 u-flex">
	
                <div class="header-center-menu" :class="{active: currentRoute === menu.path}" v-for="(menu, index) in menuList" :key="index" @click="menuChange(menu.path)">
				{{ menu.name }}</div>
            </div>
            <div class="right-box u-flex u-row-between">
                <!-- <div class="btn">{{ '帮助' }}</div> -->
<!--                <div class="btn u-m-l-50">{{ '登录' }}</div>
                <div class="btn u-m-l-40 register">{{ '注册' }}</div> -->
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'HeaderView',
        data() {
            return {
                logo_pic: require('@/assets/header/logo.png'),
                menuList: [
                    {
                        name: '首页',
                        path: '/',
                    },   
                    {
                        name: '产品介绍',
                        path: '/product',
                    },   
                    {
                        name: '使用手册',
                        path: '/manual',
                    },
				
                    // {
                    //     name: '购买服务',
                    //     path: '',
                    // },   
                    {
                        name: '应用下载',
                        path: '/download',
                    },   
                    {
                        name: '关于纳软',
                        path: '/about',
                    },   
                    {
                        name: '帮助中心',
                        path: '/help',
                    },
                ],
                right_menu: [
                    // {
                    //     name: '帮助',
                    //     path: '/',
                    // },
                    // {
                    //     name: '登录111',
                    //     path: '/',
                    // },
                    // {
                    //     name: '注册',
                    //     path: '/',
                    // },
                ]
            }
        },
		mounted() {
			this.fetchWebsiteConfig();
		},
        computed: {
            currentRoute() {
				if(this.$route.path=="/manualde"){
					return "/manual";
				}
                return this.$route.path;
            }
        },
        methods: {
			async fetchWebsiteConfig() {
				const response = await fetch(this.$apiBaseUrl+"/api/website/website_conf");
				const data = await response.json();
				this.data=data.data
				console.log(data.data)
				if(data.data.web_name){
					document.title=data.data.web_name;
				}
				
				let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
				link.type = 'image/x-icon';
				link.rel = 'shortcut icon';
				link.href = data.data.web_logo;
				document.getElementsByTagName('head')[0].appendChild(link);
			},
            menuChange(path) {
                if (path === this.currentRoute) return;
                this.$router.push(path);
            }
        }
    }
</script>

<style lang="scss" scoped>
.header-view {
    width: 100%;
    height: 90px;
    position: relative;
    z-index: 99;
    &-content {
        width: 1283px;
        height: 100%;
        margin: 0 auto;
        .logo {
            height: 40px;
        }
        .header-center {
            margin: 0 200px 0 80px;
            color: #333;
            justify-content: space-between;
            &-menu {
                font-size: 18px;
				font-weight: bold;
                cursor: pointer;
                padding-bottom: 13px;
                border-bottom: 2px solid transparent;
                margin-top: 13px;
                &:hover {
                    color: $theme-color;
                }
                &.active {
                    color: $theme-color;
                    border-bottom-color: #1184D6;
                }
            }
        }
        .right-box {
            .btn {
                cursor: pointer;
            }
            .register {
                width: 75px;
                height: 38px;
                color: #fff;
                text-align: center;
                line-height: 38px;
                position: relative;
                &::before {
                    content: '';
                    width: 60px;
                    height: 38px;
                    position: absolute;
                    z-index: -1;
                    left: 6px;
                    background: linear-gradient(20deg, #085AA9, #34BDEF);
                    box-shadow: 2px 2px 8px 0px rgba(52, 92, 156, 0.27);
                    transform: skewX(-25deg);
                }
            }
        }
    }
}
</style>